import createAction from 'utils/createAction';

const GLOBAL = {
  TOGGLE_OPENED_MODAL: 'GLOBAL.TOGGLE_OPENED_MODAL',
};

const GlobalActions = {
  manageOpenedModals: createAction<{ id: string; remove?: boolean }>(
    GLOBAL.TOGGLE_OPENED_MODAL
  ),
};

export type ToggleModalCloseCallbacks = ReturnType<
  typeof GlobalActions.manageOpenedModals
>;

export { GLOBAL as GLOBAL_ACTION_TYPES, GlobalActions };
